import styled from "styled-components";
import { Dropdown, Radio, Modal } from "semantic-ui-react";

const fontSize = '.85rem'

export const StyledSearch = styled(Dropdown)`
    &.ui.search.selection > div.divider.text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        font-size: ${fontSize};
    }

    &.ui.search.selection > div.menu.transition > .item {
        font-size: ${fontSize};
    }
    &.ui.search.dropdown input.search:focus+.text {
        color: rgba(115, 115, 115, .87) !important;
    }
    &.ui.selection.dropdown>.dropdown.icon {
        font-size: .7em;
    }
`

export const StyledRadio = styled(Radio) <{ $color: string }>`
    &.ui.radio.checkbox {
        margin: 0; 
        display: flex;
        align-items: center;
        height: 100%;
        padding: 10px 7px;
        background-color: ${({ $color }) => $color}5c;
        border-radius: 4px;
        cursor: pointer;
    }
    &.ui.radio > label {
        font-size: .75rem;
        /* color: white; */

        &:before {
            top: 50%;
            transform: translateY(-50%);
            border-color: ${({ $color }) => $color} !important;
        }

        &:after {
            top: 50%;
            transform: scale(.5) translateY(-100%);
            background-color: ${({ $color }) => $color} !important;
        }
    }
`

export const ServiceWrapper = styled('div')`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin-bottom: 15px;
`

export const InputWrapper = styled('div')`
    display: grid;
    row-gap: 10px;
    margin-bottom: 15px;
`

export const CustomModal = styled(Modal)`
    //для перекрытия стилей бутстрапа
    bottom: auto;
    top: auto;
    right: auto;
    left: auto;
    overflow: unset;

    &>.close.icon{
        right: 0.25em;
        top: 0;
        font-size: ${fontSize};
        color: rgba(0,0,0,.85);
        padding: 1em;
        margin: .25rem;
    }
`